"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extraErrorDataIntegration = void 0;

var _integration = require("../integration.js");

var _debugBuild = require("../debug-build.js");

var _is = require("../utils-hoist/is.js");

var _logger = require("../utils-hoist/logger.js");

var _normalize = require("../utils-hoist/normalize.js");

var _object = require("../utils-hoist/object.js");

var _string = require("../utils-hoist/string.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const INTEGRATION_NAME = 'ExtraErrorData';
/**
 * Extract additional data for from original exceptions.
 */

const _extraErrorDataIntegration = (options = {}) => {
  const _options$depth = options.depth,
        depth = _options$depth === void 0 ? 3 : _options$depth,
        _options$captureError = options.captureErrorCause,
        captureErrorCause = _options$captureError === void 0 ? true : _options$captureError;
  return {
    name: INTEGRATION_NAME,

    processEvent(event, hint, client) {
      const _client$getOptions = client.getOptions(),
            _client$getOptions$ma = _client$getOptions.maxValueLength,
            maxValueLength = _client$getOptions$ma === void 0 ? 250 : _client$getOptions$ma;

      return _enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
    }

  };
};

const extraErrorDataIntegration = exports.extraErrorDataIntegration = (0, _integration.defineIntegration)(_extraErrorDataIntegration);

function _enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
  if (!hint.originalException || !(0, _is.isError)(hint.originalException)) {
    return event;
  }

  const exceptionName = hint.originalException.name || hint.originalException.constructor.name;

  const errorData = _extractErrorData(hint.originalException, captureErrorCause, maxValueLength);

  if (errorData) {
    const contexts = _objectSpread({}, event.contexts);

    const normalizedErrorData = (0, _normalize.normalize)(errorData, depth);

    if ((0, _is.isPlainObject)(normalizedErrorData)) {
      // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
      // potentially truncate the data we just already normalized, with a certain depth setting.
      (0, _object.addNonEnumerableProperty)(normalizedErrorData, '__sentry_skip_normalization__', true);
      contexts[exceptionName] = normalizedErrorData;
    }

    return _objectSpread(_objectSpread({}, event), {}, {
      contexts
    });
  }

  return event;
}
/**
 * Extract extra information from the Error object
 */


function _extractErrorData(error, captureErrorCause, maxValueLength) {
  // We are trying to enhance already existing event, so no harm done if it won't succeed
  try {
    const nativeKeys = ['name', 'message', 'stack', 'line', 'column', 'fileName', 'lineNumber', 'columnNumber', 'toJSON'];
    const extraErrorInfo = {}; // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.

    for (const key of Object.keys(error)) {
      if (nativeKeys.indexOf(key) !== -1) {
        continue;
      }

      const value = error[key];
      extraErrorInfo[key] = (0, _is.isError)(value) || typeof value === 'string' ? (0, _string.truncate)(`${value}`, maxValueLength) : value;
    } // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause


    if (captureErrorCause && error.cause !== undefined) {
      extraErrorInfo.cause = (0, _is.isError)(error.cause) ? error.cause.toString() : error.cause;
    } // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)


    if (typeof error.toJSON === 'function') {
      const serializedError = error.toJSON();

      for (const key of Object.keys(serializedError)) {
        const value = serializedError[key];
        extraErrorInfo[key] = (0, _is.isError)(value) ? value.toString() : value;
      }
    }

    return extraErrorInfo;
  } catch (oO) {
    _debugBuild.DEBUG_BUILD && _logger.logger.error('Unable to extract extra data from the Error object:', oO);
  }

  return null;
}